<template>
  <div class="cf-node-properties__input">
    <input
      v-model.number="inputValue" 
      class="form-control"
      :class="{'invalid': error}"
      type="number"
      :placeholder="placeholder"
      :required="required"
    >
    <div
      v-if="errorMessage" 
      class="cf-node-properties__input-error"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputNumber',
  props: {
    value: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: [Number, String],
      default: ''
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    inputValue: {
      get() { 
        return this.value;
      },
      set(inputValue) {
        const value = inputValue === '' ? null : inputValue;
        this.$emit('input', value);
      }
    },
    errorMessage() {
      return this.error?.errorMessage;
    }
  }
};
</script>